import { Link } from "react-router-dom";

interface SectionTitleProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
            <i className={`${icon} text-xl`} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}